import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { ProtectedRoute } from "@/components/layout/protected-route";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { IconLock, IconKey, IconApiApp } from "@tabler/icons-react";

export const Route = createFileRoute("/api-access/")({
  component: ApiAccessPage,
});

function ApiAccessPage() {
  return (
    <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
      <AppShell>
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">API Access</h1>
            <p className="text-muted-foreground">
              Manage API keys and access tokens
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <IconKey className="h-5 w-5" />
                  API Keys
                </CardTitle>
                <CardDescription>
                  View and manage your API keys for external integrations
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  API key management coming soon...
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <IconApiApp className="h-5 w-5" />
                  API Documentation
                </CardTitle>
                <CardDescription>
                  Access API documentation and integration guides
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Documentation links coming soon...
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <IconLock className="h-5 w-5" />
                  Security Settings
                </CardTitle>
                <CardDescription>
                  Configure API security and access controls
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Security settings coming soon...
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </AppShell>
    </ProtectedRoute>
  );
}
